var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default"),_c('van-overlay',{attrs:{"show":_vm.isLoading}},[_c('van-loading',{staticClass:"wrapper",attrs:{"color":"#1989fa"}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }